import { ActionTree, GetterTree, MutationTree } from 'vuex';
import HomeSmartApi from '@/plugins/HomeSmartApi';
import { Role } from '@/modules/backend/Entities/Role';
import { CreateRoleData } from '@/modules/backend/Dto/CreateRoleData';

interface State {
  IsLoaded: boolean;
  Roles: Role[];
}

export const state: State = {
  IsLoaded: false,
  Roles: []
};

export const getters: GetterTree<State, unknown> = {
  Roles: (store): Role[] => store.Roles
};

export const mutations: MutationTree<State> = {
  Roles: (store, payload: Role[]) => (store.Roles = payload),
  Add: (store, payload: Role) => {
    store.Roles = store.Roles.concat(payload);
  },
  Remove: (store, roleId: number) => {
    store.Roles = store.Roles.filter((item) => item.getId() !== roleId);
  }
};

export const actions: ActionTree<State, unknown> = {
  List: async (context): Promise<Role[]> => {
    if (context.state.IsLoaded) {
      return context.getters.Roles;
    }
    const response: Role[] = await HomeSmartApi.Roles.List();
    context.commit('Roles', response);
    context.state.IsLoaded = true;
    return response;
  },
  Create: async (context, payload: CreateRoleData): Promise<Role> => {
    const response: Role = await HomeSmartApi.Roles.Create(payload);
    context.commit('Add', response);
    return response;
  },
  Remove: async (context, roleId: number): Promise<void> => {
    await HomeSmartApi.Roles.Remove(roleId);
    context.commit('Remove', roleId);
  }
};

export const roles = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
